import { apiMap } from '@common/assets/ts/const';
import { get, post, postForm } from '@common/http';

// 首页
export const apiIndex = (params: any) => {
    return get(`${apiMap.apiCmnt}/api/v1/activity/mid-autumn-reading/index`, params);
};

// 答题列表
export const apiQuestionList = () => {
    return get(`${apiMap.apiCmnt}/api/v1/activity/mid-autumn-reading/second`);
};

// 答题提交
export const apiQuestionSubmit = (params: any) => {
    return post(`${apiMap.apiCmnt}/api/v1/activity/mid-autumn-reading/answer`, params);
};

// 任务完成
export const apiFinishTask = (params: any) => {
    return post(`${apiMap.apiCmnt}/api/v1/activity/task/finish`, params);
};

// 突破
export const apiUpgrade = () => {
    return post(`${apiMap.apiCmnt}/api/v1/activity/mid-autumn-reading/upgrade`);
};

// 使用法宝 category: 1 合成 2 使用
export const apiUseMagicWeapon = (params: any) => {
    return post(`${apiMap.apiCmnt}/api/v1/activity/mid-autumn-reading/use-magic-weapon`, params);
};

// 关注
export const apiFollow = (id: string) => {
    return postForm(`${apiMap.apiXs}/api/v1/follow/do`, { type: 1, follow_id: id, });
};

// 佩戴头像挂件
export const apiWearAvatar = (id: string) => {
    // opt_type 1: 佩戴 2: 卸下
    return postForm(`${apiMap.apiCmnt}/api/v1/virtual-equity/avatar-pendant/operate`, { pendant_id: id, opt_type: '1', });
};
